export enum TableRowAppearances {
	dynamic,
	withoutHeader,
	secondary,
	subRow,
	totals,
	withAccordion,
	withAccordionGrey,
	withAccordionGreySubRow,
	withAccordionGreyFooterRow,
	inputsRow,
}
